module.exports = __webpack_public_path__ + "img/change_size.87b3cb01.svg";